export default function BlockoutEvent({ blockout }) {
  return (
    <div className="blockoutEvent">
      <p className="blockoutEvent-p">{blockout.name}</p>
    </div>
  );
}
